// dependancies
import React from "react";
import PropTypes from "prop-types";

// styles
import LabelStyled from "./Label.styled";

/**
 *
 * @param {*} props
 * if the `icon` prop is passed in a class of `label__with__symbol` is added to handle the styling of an input with an icon
 */

const Label = props => {
    const { htmlFor, text, checkbox, icon } = props;
    return (
        <LabelStyled htmlFor={htmlFor} checkbox={checkbox} className={icon && "label__with__symbol"}>
            {text}
        </LabelStyled>
    );
};

// props validation
Label.propTypes = {
    htmlFor: PropTypes.string.isRequired,
    text: PropTypes.string.isRequired,
    checkbox: PropTypes.string,
    icon: PropTypes.bool
};

export default Label;
